import { render } from "./DataPlayerNew.vue?vue&type=template&id=572ffddb&scoped=true"
import script from "./DataPlayerNew.vue?vue&type=script&lang=ts"
export * from "./DataPlayerNew.vue?vue&type=script&lang=ts"

import "./DataPlayerNew.vue?vue&type=style&index=0&id=572ffddb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-572ffddb"

export default script